export const CLIENT_ROUTE_KEYS = Object.freeze({
  RESET_TOKEN_KEY: 'tokenId',
  RESET_USER_ID_KEY: 'userId',
  PROJECT_DETAIL_PATH_KEY: 'projectCode',
  OUR_PROCESS_DETAIL_KEY: 'ourProcessDetail',
  FAQ_CATEGORY_TYPE_KEY: 'faqCategoryType'
})
export const CLIENT_ROUTES = Object.freeze({

  CLIENT_LOGIN: "/login",
  CLIENT_FORGOT_PASSWORD: "/client/forgot_password",
  CLIENT_RECOVER_PASSWORD: "/client/recover_password",
  EMAIL_SENT: "/client/email_send",

  RESET_PASSWORD: `/client/reset_password/:${CLIENT_ROUTE_KEYS.RESET_TOKEN_KEY}/:${CLIENT_ROUTE_KEYS.RESET_USER_ID_KEY}`,
  PASSWORD_RESET_SUCCESS: '/client/reset_password_success',
  // client side facing specific routes
  OUR_PROCESS: 'our_process',
  OUR_PROCESS_DETAIL: `:${CLIENT_ROUTE_KEYS.OUR_PROCESS_DETAIL_KEY}`,
  PROJECTS: 'projects',
  PROJECT_DETAIL: `:${CLIENT_ROUTE_KEYS.PROJECT_DETAIL_PATH_KEY}`, // this is being used as path params '/projects/:projectCode'
  MARKET_RESEARCH: `mrc`,
  MARKET_RESEARCH_FULL_SERVICE: `mrfsc`,
  PAST_INVOICES: 'past_invoices',
  CONNECT: 'connect',
  FAQ: {
    ROOT: '/faq',
    CATEGORY: `:${CLIENT_ROUTE_KEYS.FAQ_CATEGORY_TYPE_KEY}`
  }
})
